import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GroupError, GroupMessage } from '@/exceptions/group/group.enum';
import { groupMessageService } from '@/services/group_message.service';
import { notificationService } from '@/services/notification.service';

const useDeleteGroupMessage = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (messageUuid: string) =>
			await groupMessageService.deleteGroupMessage(messageUuid),

		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['group-message'] });
			notificationService.success(GroupMessage.GROUP_MESSAGE_DELETED);
		},

		onError: () => {
			notificationService.error(GroupError.DELETE_MESSAGE_ERROR);
			throw new Error(GroupError.DELETE_MESSAGE_ERROR);
		},
	});
};

export default useDeleteGroupMessage;
